import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useIntl } from 'react-intl';

const ShareLinksModalAnonymousLinkItem = ({ link }) => {
  const [linkCopied, setLinkCopied] = useState(false);

  const intl = useIntl();

  const copyLink = () => {
    setLinkCopied(true);
    setTimeout(() => {
      setLinkCopied(false);
    }, 2000);
  };

  return (
    <div className="share-user share-item">
      <div className="user-avatar share-avatar">
        <div className="avatar avatar-40 icon-avatar gray">
          <i className="fas fa-link" />
        </div>
      </div>
      <div className="share-item-body share-user-body">
        <h6 className="share-item-title">
          {intl.formatMessage({ defaultMessage: 'Anonymous link' })}
        </h6>
      </div>
      <div className="share-views">
        <i className="far fa-eye" />{' '}
        {link.total_views}
      </div>
      <div className="share-item-actions share-user-actions">
        <CopyToClipboard
          text={`${window.location.origin}/shares/${link.uuid}`}
          options={{
            format: 'text/plain',
          }}
          onCopy={copyLink}
        >
          {linkCopied ? (
            <span>{intl.formatMessage({ defaultMessage: 'Copied' })}</span>
          ) : (
            <a href="#copy" onClick={(e) => { e.preventDefault(); }}>
              <i className="far fa-copy" />
            </a>
          )}
        </CopyToClipboard>
      </div>
    </div>
  );
};

ShareLinksModalAnonymousLinkItem.propTypes = {
  link: PropTypes.object.isRequired,
};

export default ShareLinksModalAnonymousLinkItem;
